import React from "react";
import LegalDoc from "../components/LegalDoc";

export default function Terms() {
  return <LegalDoc docKey="terms" />;
}
